import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'

import { toFixed } from '../../../../utils/math'

import AnalyticsCardTextWithTooltip from './AnalyticsCardTextWithTooltip'

const AnalyticsCard = ({ icon, title, data, trackingData, tooltipTexts }) => {
  const { t } = useTranslation(['organisation'])
  const { total = {}, current = {}, future = {}, past = {} } = data || {}
  const { clickRate, deliveryRate, openRate } = trackingData || {}

  return (
    <div className="analytics-card">
      <h2 className="analytics-card__title">
        {icon}
        {title}
      </h2>
      <div className="analytics-card__info-items-container">
        <div className="analytics-card__info-item">
          <AnalyticsCardTextWithTooltip
            tag="h3"
            tooltipText={tooltipTexts.subscribed}
            dataId={`${title}-analytics-total`}
          >
            {t('organisation:communicationPortal.analyticsCard.subscribers')}
          </AnalyticsCardTextWithTooltip>

          <p className="total">
            {total.value}
            <span>({total.rate})%</span>
          </p>

          <AnalyticsCardTextWithTooltip
            tag="p"
            tagClassName="info"
            tooltipText={tooltipTexts.currentSubscribed}
            dataId={`${title}-current`}
          >
            <Trans
              i18nKey="organisation:communicationPortal.analyticsCard.current"
              values={{ value: current.value, rate: current.rate }}
              components={[<strong key="value" />]}
            />
          </AnalyticsCardTextWithTooltip>

          <AnalyticsCardTextWithTooltip
            tag="p"
            tagClassName="info"
            tooltipText={tooltipTexts.futureSubscribers}
            dataId={`${title}-future`}
          >
            <Trans
              i18nKey="organisation:communicationPortal.analyticsCard.future"
              values={{ value: future.value, rate: future.rate }}
              components={[<strong key="value" />]}
            />
          </AnalyticsCardTextWithTooltip>

          <AnalyticsCardTextWithTooltip
            tag="p"
            tagClassName="info"
            tooltipText={tooltipTexts.pastSubscribed}
            dataId={`${title}-past`}
          >
            <Trans
              i18nKey="organisation:communicationPortal.analyticsCard.past"
              values={{ value: past.value, rate: past.rate }}
              components={[<strong key="value" />]}
            />
          </AnalyticsCardTextWithTooltip>
        </div>

        {deliveryRate && (
          <div className="analytics-card__info-item">
            <AnalyticsCardTextWithTooltip
              tag="h3"
              tooltipText={tooltipTexts.deliveryRate}
              dataId={`${title}-deliveryRate`}
            >
              {t('organisation:communicationPortal.analyticsCard.avDeliveryRate')}
            </AnalyticsCardTextWithTooltip>
            <p className="total">{toFixed(deliveryRate * 100)}%</p>
          </div>
        )}

        {openRate && (
          <div className="analytics-card__info-item">
            <AnalyticsCardTextWithTooltip
              tag="h3"
              tooltipText={tooltipTexts.openRate}
              dataId={`${title}-openRate`}
            >
              {t('organisation:communicationPortal.analyticsCard.avOpenRate')}
            </AnalyticsCardTextWithTooltip>
            <p className="total">{toFixed(openRate * 100)}%</p>
          </div>
        )}

        {clickRate && (
          <div className="analytics-card__info-item">
            <AnalyticsCardTextWithTooltip
              tag="h3"
              tooltipText={tooltipTexts.clickRate}
              dataId={`${title}-clickRate`}
            >
              {t('organisation:communicationPortal.analyticsCard.avClickRate')}
            </AnalyticsCardTextWithTooltip>
            <p className="total">{toFixed(clickRate * 100)}%</p>
          </div>
        )}
      </div>
    </div>
  )
}

AnalyticsCard.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string,
  data: PropTypes.object,
  trackingData: PropTypes.object,
  tooltipTexts: PropTypes.object,
}

export default AnalyticsCard
